import template from './table.pug';
import _merge from 'lodash/merge';

export const FinancesTableComponent = {
  template,
  bindings: {
    filter: '<',
    onFilterChange: '&',
    onPageChange: '&',
    onCheck: '&?',
    isModal: '<?',
    records: '<',
    totalPages: '<',
    totalCount: '<',
    statusCounts: '<',
    reportsSum: '<'
  },
  controller: class FinancesTableComponent {
    constructor($async, $log, $stateParams, $localStorage, $state, $scope, MediaQuery, Finance, TableEdit, Table, $timeout) {
      'ngInject';

      this.Finance = Finance;
      this.TableEdit = TableEdit;
      this.Table = Table;
      this.$state = $state;
      this.$scope = $scope;
      this.$timeout = $timeout;

      this.$async = $async;
      this.$log = $log;
      this.$localStorage = $localStorage;
      this.$stateParams = $stateParams;
      
      this.getGroups = $async(this.getGroups.bind(this));
      this.updateStateDebounced = this.debounce(this.updateState.bind(this), 300);

      this.checkedIds = [];
      this.isLoading = false;
      this.filter = {};
      this.groups = [];
      this.selectedGroup = null;
      this.selectedStatus = null;

      // Mobile sidebar handling
      this.isMobile = MediaQuery.isMobileDevice();
      this.sidebarOpen = !this.isMobile;

      $scope.$on('mediaChange', (event, data) => {
        this.isMobile = data.isMobile;
        this.sidebarOpen = !data.isMobile;
      });
    }

    debounce(func, wait) {
      let timeout;
      return (...args) => {
        const later = () => {
          timeout = null;
          func.apply(this, args);
        };
        this.$timeout.cancel(timeout);
        timeout = this.$timeout(later, wait);
      };
    }

    updateState() {
      // Clean up params by only including non-null values
      const params = {};
      
      // Required params
      params.page = this.filter.page || 1;
      
      // Optional params
      if (this.selectedStatus) {
        params.status = this.selectedStatus;
      }
      if (this.selectedGroup && this.selectedGroup.id) {
        params.group_id = this.selectedGroup.id;
      }

      // Only include defined custom params
      ['customFieldId', 'destinationId', 'destinationType', 'previewId'].forEach(param => {
        if (this.$stateParams[param] && this.$stateParams[param] !== 'undefined') {
          params[param] = this.$stateParams[param];
        }
      });

      this.$state.go('.', params, { 
        notify: false,
        reload: false,
        location: 'replace',
        inherit: false
      });
    }

    $onInit() {
      this.gridOptions = this.TableEdit.gridOptions(this.isModal);
      this.gridOptions.enableRowSelection = false;
      this.gridOptions.enableRowHeaderSelection = true;
      this.gridOptions.enableSelectAll = true;
      this.gridOptions.columnDefs = this.TableEdit.resolveColumns('finance', 'finances', this.isModal);
      
      // Initialize filter with defaults
      this.filter = {
        page: 1,
        ...(this.filter || {})  // Preserve any existing filter values
      };

      // Initialize selected status and group from URL params
      if (this.$stateParams.status) {
        this.selectedStatus = this.$stateParams.status;
        this.filter.status = this.selectedStatus;
      }

      if (this.$stateParams.group_id) {
        const groupId = parseInt(this.$stateParams.group_id);
        this.filter.group_id = groupId;
      }

      this.getGroups();
    }

    $onChanges({ filter } = {}) {
      if (filter && filter.currentValue) {
        this.checkedIds = [];
        // Merge new filter with existing to preserve status and group
        this.filter = {
          ...this.filter,
          ...filter.currentValue
        };
        if (!this.filter.page) {
          this.filter.page = 1;
        }
      }
    }

    selectStatus(status) {
      this.selectedStatus = status;
      
      const newFilter = { 
        ...this.filter,
        page: 1
      };
      
      if (status) {
        newFilter.status = status;
      } else {
        delete newFilter.status;
      }
      
      this.filter = newFilter;
      this.updateStateDebounced();
      this.onFilterChange({$event: { filter: newFilter }});
    }

    selectGroup(group) {
      this.selectedGroup = group;
      
      const newFilter = { 
        ...this.filter,
        page: 1
      };
      
      if (group) {
        newFilter.group_id = group.id;
      } else {
        delete newFilter.group_id;
      }
      
      this.filter = newFilter;
      this.updateStateDebounced();
      this.onFilterChange({$event: { filter: newFilter }});
    }

    updatePage(event) {
      const page = event && event.page ? parseInt(event.page) : 1;
      if (page > 0) {
        const newFilter = { 
          ...this.filter,
          page
        };
        this.filter = newFilter;
        this.updateStateDebounced();
        this.onPageChange({$event: { filter: newFilter }});
      }
    }

    applyFilter(event) {
      const filterUpdate = event && event.filter ? event.filter : null;
      if (!filterUpdate) return;
      
      const newFilter = {
        ...this.filter,
        ...filterUpdate,
        page: 1
      };

      if (this.selectedStatus) {
        newFilter.status = this.selectedStatus;
      }
      if (this.selectedGroup) {
        newFilter.group_id = this.selectedGroup.id;
      }
      
      this.filter = newFilter;
      this.updateStateDebounced();
      this.onFilterChange({$event: { filter: newFilter }});
    }

    async getGroups() {
      try {
        this.groups = await this.Finance.getGroups();
        if (this.$stateParams.group_id) {
          const groupId = parseInt(this.$stateParams.group_id);
          this.selectedGroup = this.groups.find(g => g.id === groupId) || null;
        }
      } catch (err) {
        this.$log.error('Error loading groups:', err);
        this.groups = [];
      }
    }

    checkedRecords(event) {
      const checkedIds = event && event.checkedIds ? event.checkedIds : [];
      this.checkedIds = checkedIds;
      if (this.onCheck) {
        this.onCheck({ checkedIds });
      }
    }

    addFinance() {
      this.$state.go('finances.new');
    }

    toggleSidebar() {
      this.sidebarOpen = !this.sidebarOpen;
    }
  }
};
